import { ArrowRight } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

import { Button } from 'src/components';
import { Highlight } from 'src/components/Highlight';
import { ValueProps } from 'src/components/Offers/ValueProps';
import { PromotionCheckoutLink } from 'src/components/PromotionCheckoutLink';
import { StackedSheet } from 'src/components/StackedSheet';
import { SKU } from 'src/utils/skus';
import { URLS } from 'src/utils/urls/urls';
import { valueProps } from 'src/utils/valueProps';

import { Trans, useLingui } from '@lingui/react/macro';
import { Price } from '../Price';

export const SubscribeHero = ({
  componentLocation,
}: {
  componentLocation: string;
}) => {
  const { t } = useLingui();
  return (
    <StackedSheet dataCy="subscribe-hero">
      <div className="flex flex-col gap-24 text-left lm:gap-32">
        <div className="flex flex-col gap-24">
          <Typography variant="responsive-heading-lg" className="text-pretty">
            <Trans>
              Subscribe to <Highlight scale={150}>Connect</Highlight>
            </Trans>
          </Typography>
        </div>

        <div data-cy="connect-offer-perks" className="w-full">
          <ValueProps
            className="justify-start"
            valueProps={valueProps.connect}
          />
        </div>
        <div className="flex flex-wrap items-center gap-24">
          <Button
            as="a"
            variant="primary"
            to={URLS.STORE_CONNECT_CHECKOUT}
            className="grow ll:grow-0"
            data-cy="landing-next-step"
            analytics={{
              location: componentLocation,
              text: t`Get Connect`,
              action: 'subscribe to connect',
            }}
          >
            <span data-cy="store-activate-button">
              <Trans>Get Connect</Trans>
            </span>
            <ArrowRight />
          </Button>
          <PromotionCheckoutLink componentLocation={componentLocation} />
        </div>

        <Typography variant="interface-sm" leadingNone>
          <span>
            <Trans>
              Connect costs <Price sku={SKU.connectMonthly} />
              /mo. <b>Cancel anytime.</b>
            </Trans>
          </span>
        </Typography>
      </div>
    </StackedSheet>
  );
};
